// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__qq5vF","isSimpleHover":"button_isSimpleHover__LGfoZ","secondaryBtn":"button_secondaryBtn__Ahm7Y"};